module.exports = `
  <!DOCTYPE html>
  <html lang="en">
    <head>
      <title>Screen Test Machine</title>
      <meta property="og:title" content="Screen Test Machine" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta charset="utf-8" />
      <meta property="twitter:card" content="summary_large_image" />
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100..900;1,100..900&family=Hanken+Grotesk:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet">
      <style data-tag="reset-style-sheet">
        html {
          line-height: 1.15;
        }

        body {
          margin: 0;
        }

        * {
          box-sizing: border-box;
          border-width: 0;
          border-style: solid;
          -webkit-font-smoothing: antialiased;
        }

        p,
        li,
        ul,
        pre,
        div,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        figure,
        blockquote,
        figcaption {
          margin: 0;
          padding: 0;
        }

        button {
          background-color: transparent;
        }

        button,
        input,
        optgroup,
        select,
        textarea {
          font-family: inherit;
          font-size: 100%;
          line-height: 1.15;
          margin: 0;
        }

        button,
        select {
          text-transform: none;
        }

        button,
        [type="button"],
        [type="reset"],
        [type="submit"] {
          -webkit-appearance: button;
          color: inherit;
        }

        button::-moz-focus-inner,
        [type="button"]::-moz-focus-inner,
        [type="reset"]::-moz-focus-inner,
        [type="submit"]::-moz-focus-inner {
          border-style: none;
          padding: 0;
        }

        button:-moz-focus,
        [type="button"]:-moz-focus,
        [type="reset"]:-moz-focus,
        [type="submit"]:-moz-focus {
          outline: 1px dotted ButtonText;
        }

        a {
          color: inherit;
          text-decoration: inherit;
        }
        a:hover, a:focus {
          text-decoration: underline;
        }

        input {
          padding: 2px 4px;
        }

        img {
          display: block;
          max-width: 100%;
        }

        details {
          display: block;
          margin: 0;
          padding: 0;
        }

        summary::-webkit-details-marker {
          display: none;
        }

        [data-thq="accordion"] [data-thq="accordion-content"] {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease-in-out;
          padding: 0;
        }

        [data-thq="accordion"] details[data-thq="accordion-trigger"][open]+[data-thq="accordion-content"] {
          max-height: 1000vh;
        }

        details[data-thq="accordion-trigger"][open] summary [data-thq="accordion-icon"] {
          transform: rotate(180deg);
        }

        html {
          scroll-behavior: smooth
        }
      </style>
      <style data-tag="default-style-sheet">
        html {
          font-family: "Hanken Grotesk", sans-serif;
          font-size: 16px;
        }

        body {
          font-weight: 400;
          font-style: normal;
          /* text-decoration: none; */
          text-transform: none;
          letter-spacing: normal;
          line-height: 1.15;
          color: var(--dl-color-theme-neutral-dark);
          background: var(--dl-color-theme-neutral-light);
          fill: var(--dl-color-theme-neutral-dark);
        }
      </style>
      <link rel="stylesheet" href="https://unpkg.com/animate.css@4.1.1/animate.css" />
      <link rel="stylesheet" href="https://unpkg.com/@teleporthq/teleport-custom-scripts/dist/style.css" />
      <link rel="stylesheet" href="/static-frontpage/style.css" />
      <link href="/static-frontpage/index.css" rel="stylesheet" />
      <!-- Google tag (gtag.js) -->
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-XCKZMFG9VB"></script>
      <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
  
      gtag('config', 'G-XCKZMFG9VB');
      </script>
    </head>
    <body>
      <div>
        <div class="home-container">
          <navbar2-wrapper class="navbar2-wrapper" rootclassname="navbar2undefined">
            <!--Navbar2 component-->
            <header class="navbar2-container navbar2root-class-name">
              <div class="hero8-max-width thq-section-max-width">
                <div data-thq="thq-navbar" class="navbar2-navbar-interactive">
                  <img alt="The Andy Warhol Museum" src="./static-frontpage/components/the-warhol_all-white.png" class="navbar2-image1" />
                </div>
              </div>
            </header>
          </navbar2-wrapper>
          <hero8-wrapper class="hero8-wrapper" rootclassname="hero8undefined">
            <!--Hero8 component-->
            <div class="hero8-header26 thq-section-padding hero8root-class-name">
              <div class="hero8-max-width thq-section-max-width ">
                <div class="hero8-column">
                  <div class="hero8-content">
                    <div class="hero8-logo">
                      <img src="./static-frontpage/components/screen-test-machine_logo.png" alt="Screen Test Machine"/>
                    </div>
                    <h1 class="sr-only">Screen Test Machine</h1>
                  </div>
                </div>
                <div style="margin-top:2rem;padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/1088494596?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Screen Test Machine at The Andy Warhol Museum"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
              </div>
            </div>
          </hero8-wrapper>
          <content-list1-wrapper class="content-list1-wrapper">
            <!--ContentList1 component-->
            <div class="content-list1-container thq-section-padding">
              <div class="content-list1-max-width thq-section-max-width">
                <div class="content-list1-content thq-flex-column">
                  <ul class="content-list1-ul thq-flex-column">
                    <li class="list-item thq-flex-column" id="about">
                      <h2 class="content-list1-heading1 thq-heading-2">
                        <fragment class="home-fragment26">
                          <span class="home-text26">About the Screen Test Machine</span>
                        </fragment>
                      </h2>
                      <p class="thq-body-small">
                        <fragment class="home-fragment20">
                          <span class="home-text20">In a gallery reminiscent of Warhol's Silver Factory studio, Museum visitors are invited to create their own screen test utilizing a computer touch screen, a moveable backdrop, a specially modified vintage camera, and twin studio lights. Upon completion, the visitor's screen test is transformed digitally from real time to slow motion and pushed to the Internet, where it will be available on a custom webpage. The screen test can be shared on various social media channels.</span>
                        </fragment>
                      </p>
                    </li>
                    <li class="list-item">
                      <h3 class="thq-heading-3">
                        <fragment class="home-fragment27">
                          <span class="home-text27">About Andy Warhol's Screen Tests</span>
                        </fragment>
                      </h3>
                      <p class="thq-body-small">
                        <fragment class="home-fragment21">
                          Warhol's filmmaking was motivated in large part by his fascination with individuals, but he was also driven by his desire to capture the actual experience of living. As he wrote in his book, <i>POPism: The Warhol '60s</i>: "What I liked was chunks of time all together, every real moment... I only wanted to find great people and let them be themselves and I'd film them for a certain length of time and that would be the movie."
                        </fragment>
                      </p>

                      <p class="thq-body-small">
                        <fragment class="home-fragment21">
                          Warhol's <i>Screen Tests</i>, which number approximately 500, are revealing portraits of hundreds of different individuals, shot between 1964 and 1966. The subjects are both regulars of the Factory scene and new visitors-both famous and anonymous. They were all asked to pose to be captured by Warhol's stationary 16mm Bolex movie camera on silent, black and white, 100-foot rolls of film.  Each screen test was exactly the same length, lasting only as long as the roll of film, about 2 ¾ minutes. The resulting films were projected in slow motion so that each lasted approximately four minutes. For exhibition, Warhol strung the <i>Screen Tests together</i> in a sequence, inducing an almost hypnotic reverie that could "help the audiences get more acquainted with themselves," as he once said.
                        </fragment>
                      </p>

                      <p class="thq-body-small">
                        <fragment class="home-fragment21">
                          Although these film portraits were referred to by the Hollywood term of "screen test," none of them appear to have been used for the purpose of actually testing or auditioning prospective actors.  Many were included in compilation films such as the flatteringly-titled <i>13 Most Beautiful Women</i>, <i>13 Most Beautiful Boys</i>, and <i>50 Fantastics and 50 Personalities</i>, which were projected in different versions each time they were screened, depending on who was in the audience or who Warhol wanted to please.  Ultimately, Warhol left 89 reels of film marked "13" - 42 <i>Screen Tests</i> of 35 different men and 47 <i>Screen Tests</i> of 30 different women.
                        </fragment>
                      </p>

                      <p class="thq-body-small">
                        <fragment class="home-fragment21">
                          Also, the <i>Screen Tests</i> and other Warhol films were used, accompanied by strobes, mirror ball reflections and other visual effects, as part of the light show for his 1966-67 multi-media happenings, <i>Andy Warhol Up-Tight</i> and the <i>Exploding Plastic Inevitable</i>, which featured the music of the Velvet Underground and Nico.
                        </fragment>
                      </p>

                      <p class="thq-body-small">
                        <fragment class="home-fragment21">
                          It has often been written that Warhol simply turned on the camera and walked away.  However, as can be seen in a 1964 film, made by the British Broadcasting Company, called <i>Cheese! Or What Really Did Happen in Andy Warhol's Studio</i>, Warhol was actively engaged in shooting Susan Sontag's <i>Screen Test</i>. He set up the camera, framed the shot, and engaged the sitter before filming. Here, Warhol chats with Sontag, answering her questions about her on-screen behavior and suggesting that she move as little as possible. For other <i>Screen Tests</i>, an assistant might have loaded the camera, while Warhol stayed in the background and chatted with friends or visitors who were there to be a part of the experience. Whatever the interaction or presumed lack of interaction between Warhol and his subject, he used the filming process to communicate with and learn about people. Even when he wasn't in the room, the camera remained as a surrogate for his presence.
                        </fragment>
                      </p>

                      <p class="thq-body-small">
                        <fragment class="home-fragment21">
                          Many of Warhol's <i>Screen Tests</i> fit the standard formula-the subject and the camera almost motionless for the duration of the film, with the result as close to a "living portrait" as possible.  However, within this format, there are subtle variations.  Starkly lit with a single lamp, a glowering Paul America and the intense Susan Bottomly are sharply contrasted by the dark background, while Ann Buchanan and Edie Sedgwick's <i>Screen Tests</i> were fully lit, allowing the viewer to notice every subtle change in their almost unmoving faces. In addition, there are a number of <i>Screen Tests</i> that entirely diverge from this format, some with wide shots that take in the sitter's body as well as their face; one-takes that start with a close up on a facial feature, such as an eye, or teeth or lips, and then slowly zoom out to reveal the sitter's face; and hyper-edited versions, in which the <i>Screen Test</i> is broken up by in-camera edits.
                        </fragment>
                      </p>

                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </content-list1-wrapper>
          <footer4-wrapper class="footer4-wrapper" rootclassname="footer4undefined">
            <!--Footer4 component-->
            <footer class="footer4-footer7 thq-section-padding footer4root-class-name">
              <div class="footer4-max-width thq-section-max-width">
                <div class="footer4-content">
                  <div class="footer4-logo1">
                    <img alt="The Andy Warhol Museum" src="./static-frontpage/components/TAWM-full-logo--white.png" class="footer4-logo2" />
                  </div>
                  <p>The Screen Test Machine is an interactive experience developed by The Andy Warhol Museum.</p>
                  <p>The Screen Test Machine is available to rent as part of our Exhibition Rental service or it can be added to a Museum Rental, inquire at <a href="https://www.warhol.org/contact" target="_blank"">warhol.org/contact.</a></p>
                </div>
                <div class="footer4-credits">
                  <div class="thq-divider-horizontal"></div>
                  <div class="footer4-row">
                    <div class="footer4-container">
                      <span class="thq-body-small"><span>© <span id="year"></span> The Andy Warhol Museum</span>
                    </div>
                    <div class="footer4-footer-links">
                      <a href="https://www.warhol.org/legal-notice/" target="_blank" rel="noreferrer noopener" class="thq-body-small">
                        Legal Notice
                      </a>
                      <a href="https://carnegiemuseums.org/privacy-policy/" target="_blank" rel="noreferrer noopener" class="thq-body-small">
                        Privacy Policy
                      </a>
                      <a href="https://www.warhol.org/contact/" target="_blank" rel="noreferrer noopener" class="thq-body-small">
                        Support
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          </footer4-wrapper>
        </div>
      </div>
      <script>
        document.getElementById("year").innerHTML = new Date().getFullYear();
      </script>
    </body>
  </html>
`;